import PropTypes from 'prop-types';

const TableDataShape = PropTypes.objectOf(
  PropTypes.shape({
    subText: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    isPending: PropTypes.bool
  })
);

export default TableDataShape;
